import { createTheme } from "@mantine/core";

export const theme = createTheme({
    colors: {
        kobleBlue: [
            "#F6FDFE",
            "#F6FDFE",
            "#DBF9FB",
            "#C1F4F8",
            "#A6EFF5",
            "#85BFC4",
            "#648F93",
            "#426062",
            "#426062",
            "#426062",
        ],
        kobleOlive: [
            "#F6FDE9",
            "#F6FDE9",
            "#EEFBD4",
            "#E5F9BE",
            "#D4F593",
            "#D4F593",
            "#94AB67",
            "#6A7A49",
            "#3F492C",
            "#3F492C",
        ],
        kobleLavender: [
            "#FAF8FE",
            "#FAF8FE",
            "#EBE3FB",
            "#DDCFF8",
            "#CEBAF5",
            "#CEBAF5",
            "#A595C4",
            "#7C7093",
            "#524A62",
            "#524A62",
        ],
        kobleYellow: [
            "#FFFDF5",
            "#FFFDF5",
            "#FFF7D6",
            "#FFF1B8",
            "#FFEB99",
            "#FFEB99",
            "#CCBC7A",
            "#998D5C",
            "#665E3D",
            "#665E3D",
        ],
        kobleRed: [
            "#FEF&FS",
            "#FEF&FS",
            "#FBE3E3",
            "#F8CFCF",
            "#F5BABA",
            "#F5BABA",
            "#C49595",
            "#937070",
            "#624A4A",
            "#624A4A",
        ],
    },
    primaryColor: "kobleBlue",
});
